import React, { useContext } from 'react';

import * as FormSelectors from 'Pages/manageproduction/helpers/formSelectors';
import { ProductionRecordDetailFieldEnum as ProdRecordDetailFields } from 'Common/FieldEnum';

import { CountSection } from './CountSection';
import { EditProductionFormContext } from './EditProductionForm';

function ServedSection(props) {
  const state = useContext(EditProductionFormContext);
  const recipeCategoryIds = Object.keys(props.detailsByRecipeCategory);
  const servedTotalByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.Served,
    recipeCategoryIds
  );

  const servedAlacarteTotalByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.ServedAlacarte,
    recipeCategoryIds
  );
  const servedAdultTotalByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.ServedAdult,
    recipeCategoryIds
  );
  const leftoverTotalByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.Leftover,
    recipeCategoryIds
  );
  const discardTotalByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.Discard,
    recipeCategoryIds
  );
  const servedReimbTotalByRecCat = FormSelectors.getServedReimbTotalByRecCat(
    state,
    recipeCategoryIds
  );
  const servedPreKTotalByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.ServedPreK,
    recipeCategoryIds
  );

  return (
    <CountSection
      {...props}
      headerProps={{
        servedTotalByRecCat,
        servedAlacarteTotalByRecCat,
        servedAdultTotalByRecCat,
        leftoverTotalByRecCat,
        discardTotalByRecCat,
        servedReimbTotalByRecCat,
        servedPreKTotalByRecCat,
      }}
    />
  );
}

export { ServedSection };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/ServedSection.js